import {
  Autocomplete,
  TextField,
  Table,
  TableBody,
  TableRow,
  TableCell,
  TableContainer,
  Paper,
} from "@mui/material";
import { UseFormReturn } from "react-hook-form";
import { useMutation } from "react-query";
import { ChangeEvent, useContext, useEffect } from "react";
import { EncounterContext, EncounterContextType } from ".";
import { useLocation, useParams } from "react-router-dom";
import { useFetchPatientDetailsByEMR } from "../../hookv2/apiHooks";
import {
  InsurancePatientType,
  PatientFullDetailsType,
} from "../../PatientBooking/v2/types";
import { getAmount } from "../../../MainDashboard/Wallet/service";
import usePopup from "../../../hooks/usePopup";
import { getAllPatients } from "../services";
import { getPatientGroupingDisplay } from "../../../utilis/methods/patientGrouping";

const QATAR_ID_MAX_LENGTH = 11;

const normalizeQatarId = (value?: string | null) => {
  if (!value) return value ?? undefined;
  return value.replace(/\D/g, "").slice(0, QATAR_ID_MAX_LENGTH);
};

function PatientDetails({ formcontrol }: { formcontrol: UseFormReturn }) {
  // const base = (window as any)._env_?.BASE_URL;
  const { id, idType, emrno } = useParams();
  const location = useLocation();
  const context = useContext(EncounterContext);
  // const navigateto = useNavigate();
  const {showSnackbar}=usePopup()
  const {
    setEncounter,
    setInusranceId,
    setEncounterDetails,
    setSearchflag,
    // searchflag,
    encounterDetails,
  } = context as EncounterContextType;
  const { reset: resetform } = formcontrol;

  // const [patientList, setPatientList] = useState<Patient[]>([]);
  const { mutate: SearchPatient, data: allpatientsList } =
    useMutation(getAllPatients);

 const {mutate:getamount}=useMutation(getAmount,{onSuccess:(data)=>{
      if(data.response[0].amount<0){
        showSnackbar({
          message: "The patient has some dues",
          open: true,
          variant: "info"
        })
      }
   }})
   

  const { mutate: SearchPatientByEmr, data: PatientInfo } =
    useFetchPatientDetailsByEMR({
      onSuccess: (data) => {
        const details = { ...data.response };
   

        Boolean(
          (data.response.insurancePatient as InsurancePatientType)?.insurance
        )
          ? (details.insurancePatient = data.response.insurancePatient)
          : (details.insurancePatient = null);

        if (details?.encounter?.departmentId && details?.encounter?.doctorId) {
          details.patientDetails = {
            ...details.patientDetails,
            departmentId: details.encounter.departmentId,
            doctorId: details.encounter.doctorId,
          };
        }

        setEncounterDetails(details);
      },
    });

  // const { mutate: SearchPatientByEmrOld, } =
  //   useFetchPatientDetailsByEMROld({
  //     onSuccess: (data) => {
  //       if(typeof data == "object"){
  //         console.clear();
  //         setEncounterDetails(data);
  //     }
  //   }});

  // navigateto("/react/main/insurance/verification/12/15",{ replace: true })
  // const existingEncounter=localStorage.getItem(storageKey.encounterData)
  if (!context) {
    throw new Error(
      "EncounterComponent must be used within an EncounterProvider"
    );
  }

  const searchData = (e: ChangeEvent<HTMLInputElement>) => {
    // if (searchflag && emrno) {
    //   navigateto(`${base}iframe/encounter/${emrno}`);
    // }
    const { value } = e.target;
    SearchPatient(value);
  };

  const getPatientData = (_: any, data: any) => {
    console.log(data);
    if(data){
      setSearchflag(true);
      SearchPatientByEmr({ emrNo: data?.patientId, });
      getamount(data?.id)
      if (emrno) {
        setEncounter(PatientInfo?.response.encounter?.encounterId as number);
        setInusranceId(
          (PatientInfo?.response?.insurancePatient as InsurancePatientType)
          ?.id as number
        );
        setEncounterDetails(PatientInfo?.response as PatientFullDetailsType);
      } else {
        resetform();
      }
    }else{
      setEncounterDetails(null);
      resetform();
    }
  };

  // const allIdTypes = {
  //   Emirates: "emiratesId",
  //   Passport: "passportId",
  //   GCC: "gccId",
  // };
  const allIdTypes = {
    Qatar: "emiratesId",
    Emirates: "emiratesId",
    Passport: "passNum",
    GCC: "gccId",
  };

  const getPatientIdParam = (routeId?: string, routeIdType?: string) => {
    if (!routeId) return routeId;
    if (routeIdType === "Qatar") {
      return normalizeQatarId(routeId);
    }
    return routeId;
  };

  useEffect(() => {
     SearchPatient("a");
    const queryParams = new URLSearchParams(location.search);
    const bookingId = queryParams.get("bookingId")
    ? parseInt(queryParams.get("bookingId") || "0")
    : null;
    const encounterId = parseInt(queryParams.get("encounterid") || "0") || null
      if (id && idType) {
        const patientIdValue = getPatientIdParam(id, idType);
        let getPatientparams:{emiratesId?:string,passportId?:string,gccId?:string,bookingId?:number} = {
          [allIdTypes[idType as keyof typeof allIdTypes]]: patientIdValue,
        }
        bookingId && (getPatientparams = { ...getPatientparams, bookingId });
        SearchPatientByEmr({...getPatientparams});
    }

    try {
      if (emrno) {
        let params: { emrNo: string; bookingId?: number | null,encounterId?: number | null  } = {
          emrNo: emrno,
          encounterId,
        };
        bookingId && (params = { ...params, bookingId });
        SearchPatientByEmr(params);
        setEncounterDetails(PatientInfo?.response as PatientFullDetailsType);
      } else {
        setEncounterDetails(null);
      }
    } catch (error) {}
  }, [emrno]);

  return (
    <section>
      <div className="">
        <div className="grid grid-cols-8 items-center border-b-2 py-2 px-1">
          <h4 className=" col-span-5 text-base font-bold">Patient Details</h4>
          {!emrno && (
            <div className="col-span-3">
              <Autocomplete
                options={allpatientsList?.response || []}
                getOptionLabel={(option: any) =>
                  `${option.patientId} ${option.firstName} ${option?.middleName || ""} ${option.lastName}`
                }
                renderOption={(props, option: any) => (
                  <li {...props}>
                    <div className="flex flex-col w-full  border-b border-gray-200 py-2 px-1">
                      <div className="flex gap-6 ">
                        <span className="font-medium">
                          {"Name: " + option.firstName} {option?.middleName || ""} {option.lastName}
                        </span>
                        <span>
                          {"EMR No: " + option.patientId}
                        </span>
                      </div>

                      <div className="flex gap-6 text-xs text-gray-500">
                        <span>{"Ph: " + option.mobileNo}</span>
                        <span>{"Id: " + option.emiratesId}</span>
                      </div>
                    </div>
                  </li>
                )}
                filterOptions={(options) => options}
                isOptionEqualToValue={(option, value) => option.id == value.id}
                onChange={getPatientData}
                renderInput={(props) => (
                  <TextField
                    {...props}
                    label="Search Patient"
                    onChange={searchData}
                  />
                )}
              />
            </div>
          )}
        </div>
        {Boolean(encounterDetails) && (
          <TableContainer
            component={Paper}
            className="flex flex-row justify-between p-2 mt-2"
          >
            <Table size="small">
              <TableBody>
                <TableRow>
                  <TableCell sx={{ border: 0 }}>Name </TableCell>
                  <TableCell sx={{ border: 0 }}>
                    :{" "}
                    <strong>
                      {encounterDetails?.pmaster?.firstName} {encounterDetails?.pmaster?.middleName || ""} {encounterDetails?.pmaster?.lastName}
                    </strong>
                  </TableCell>
                  <TableCell sx={{ border: 0 }}>EMR No/Reg No</TableCell>
                  <TableCell sx={{ border: 0 }}>
                    : <strong>{encounterDetails?.pmaster?.patientId}</strong>
                  </TableCell>
                </TableRow>
                <TableRow>
                  <TableCell sx={{ border: 0 }}>
                    {Boolean(encounterDetails?.pmaster?.emiratesId) &&
                      "Qatar Id"}
                    {Boolean(encounterDetails?.pmaster?.gccId) && "GCC Id"}
                    {Boolean(encounterDetails?.pmaster?.passportNum) &&
                      "Passport Id"}
                  </TableCell>
                  <TableCell sx={{ border: 0 }}>
                    :{" "}
                    <strong>
                      {encounterDetails?.pmaster?.emiratesId ||
                        encounterDetails?.pmaster?.gccId ||
                        encounterDetails?.pmaster?.passportNum}
                    </strong>
                  </TableCell>
                  <TableCell sx={{ border: 0 }}>Mobile</TableCell>
                  <TableCell sx={{ border: 0 }}>
                    : <strong>{encounterDetails?.amaster?.mobileNo}</strong>
                  </TableCell>
                </TableRow>
                <TableRow>
                  <TableCell sx={{ border: 0 }}>Grouping</TableCell>
                  <TableCell sx={{ border: 0 }} colSpan={3}>
                    :{" "}
                    <strong>
                      {getPatientGroupingDisplay(encounterDetails) || "-"}
                    </strong>
                  </TableCell>
                </TableRow>
              </TableBody>
            </Table>
          </TableContainer>
        )}
      </div>
    </section>
  );
}

export default PatientDetails;
